import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductList from './ProductList';
import { products } from '../data/products';
import './Home.css';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const categories = products.categories.slice(0, 3); // Show first 3 categories

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % categories.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [categories.length]);

  const handleWhatsAppInquiry = () => {
    const message = encodeURIComponent(
      "Hello! I'm interested in your products. Can you provide more information?"
    );
    window.open(`https://wa.me/923427374035?text=${message}`, '_blank');
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-slider">
          {categories.map((category, index) => (
            <div 
              key={index} 
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                opacity: index === currentSlide ? 1 : 0,
                transition: 'opacity 0.5s ease-in-out'
              }}
            >
              <img 
                src={`${process.env.PUBLIC_URL}${category.images[0]}`} 
                alt={category.name}
                className="hero-image"
              />
            </div>
          ))}
        </div>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <h1>Handcrafted Leather Excellence</h1>
            <p>Discover our premium collection of leather products and percussion instruments</p>
            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={handleWhatsAppInquiry}>
                <span className="whatsapp-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20">
                    <path fill="currentColor" d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564c.173.087.289.129.332.202.043.073.043.423-.101.827z"/>
                  </svg>
                </span>
                Contact on WhatsApp
              </button>
              <Link to="/products" className="btn btn-secondary">
                View Products
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Categories */}
      <section className="categories-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Collections</h2>
            <p>Browse through our specialized collections</p>
            <div className="section-divider">
              <span className="divider-icon">★</span>
            </div>
          </div>
          <div className="categories-grid">
            {categories.map((category, index) => (
              <div key={index} className="category-card">
                <div className="category-gallery">
                  {category.images.slice(0, 2).map((image, imgIndex) => (
                    <div key={imgIndex} className="gallery-item">
                      <img 
                        src={`${process.env.PUBLIC_URL}${image}`} 
                        alt={`${category.name} ${imgIndex + 1}`}
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
                <div className="category-content">
                  <h3>{category.name}</h3>
                  <p>{category.description}</p>
                  <div className="category-actions">
                    <button 
                      className="whatsapp-inquiry-btn"
                      onClick={() => {
                        const message = encodeURIComponent(
                          `Hello! I'm interested in your ${category.name}. Can you provide more information?`
                        );
                        window.open(`https://wa.me/923427374035?text=${message}`, '_blank');
                      }}
                    >
                      <span className="whatsapp-icon">
                        <svg viewBox="0 0 24 24" width="18" height="18">
                          <path fill="currentColor" d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564c.173.087.289.129.332.202.043.073.043.423-.101.827z"/>
                        </svg>
                      </span>
                      Inquire on WhatsApp
                    </button>
                    <Link 
                      to={`/products?category=${category.id}`} 
                      className="view-collection-btn"
                    >
                      View Collection
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="featured-section">
        <div className="container">
          <div className="section-header">
            <h2>Featured Products</h2>
            <p>Our most popular handcrafted items</p>
            <div className="section-divider">
              <span className="divider-icon">★</span>
            </div>
          </div>
          <ProductList />
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Us</h2>
            <p>Discover what makes our leather products unique</p>
            <div className="section-divider">
              <span className="divider-icon">★</span>
            </div>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" width="40" height="40">
                  <path fill="currentColor" d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM13 16h-2v2h2v-2zm0-6h-2v4h2v-4z"/>
                </svg>
              </div>
              <h3>Premium Quality</h3>
              <p>We use only the finest leather materials, carefully selected for durability and beauty</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" width="40" height="40">
                  <path fill="currentColor" d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
              </div>
              <h3>Competitive Pricing</h3>
              <p>Get exceptional value with our direct-to-customer pricing model</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" width="40" height="40">
                  <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"/>
                </svg>
              </div>
              <h3>Satisfaction Guaranteed</h3>
              <p>Your satisfaction is our priority, backed by our quality guarantee</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" width="40" height="40">
                  <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-4h2v2h-2zm1.61-9.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.12.34-.2.75-.2 1.25h2c0-.42.11-.77.28-1.07.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47z"/>
                </svg>
              </div>
              <h3>Expert Support</h3>
              <p>Get personalized assistance from our leather crafting experts</p>
            </div>
          </div>
        </div>
      </section>

      {/* Customer Reviews */}
      <section className="reviews-section">
        <div className="container">
          <div className="section-header">
            <h2>What Our Customers Say</h2>
            <p>Read testimonials from our satisfied customers</p>
            <div className="section-divider">
              <span className="divider-icon">★</span>
            </div>
          </div>
          <div className="reviews-grid">
            <div className="review-card">
              <div className="review-rating">★★★★★</div>
              <p className="review-text">"Exceptional quality and craftsmanship. The attention to detail is remarkable!"</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">JD</div>
                <div className="reviewer-details">
                  <h4>John Doe</h4>
                  <p>Verified Customer</p>
                </div>
              </div>
            </div>
            <div className="review-card">
              <div className="review-rating">★★★★★</div>
              <p className="review-text">"The leather quality is outstanding. These products are built to last!"</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">AS</div>
                <div className="reviewer-details">
                  <h4>Alice Smith</h4>
                  <p>Verified Customer</p>
                </div>
              </div>
            </div>
            <div className="review-card">
              <div className="review-rating">★★★★★</div>
              <p className="review-text">"Great customer service and beautiful products. Highly recommended!"</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">RJ</div>
                <div className="reviewer-details">
                  <h4>Robert Johnson</h4>
                  <p>Verified Customer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Crafting Process</h2>
            <p>Discover how we create our premium leather products</p>
            <div className="section-divider">
              <span className="divider-icon">★</span>
            </div>
          </div>
          <div className="process-timeline">
            <div className="timeline-item">
              <div className="timeline-number">1</div>
              <div className="timeline-content">
                <h3>Material Selection</h3>
                <p>We carefully select the finest leather materials from trusted suppliers</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">2</div>
              <div className="timeline-content">
                <h3>Design & Planning</h3>
                <p>Each piece is thoughtfully designed to ensure both beauty and functionality</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">3</div>
              <div className="timeline-content">
                <h3>Handcrafting</h3>
                <p>Our skilled artisans carefully craft each piece with attention to detail</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">4</div>
              <div className="timeline-content">
                <h3>Quality Check</h3>
                <p>Each product undergoes rigorous quality checks before shipping</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <h2>Stay Updated</h2>
            <p>Subscribe to our newsletter for exclusive offers and updates</p>
            <form className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address"
                className="newsletter-input"
              />
              <button type="submit" className="btn btn-primary">Subscribe</button>
            </form>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="section-divider">
              <span className="divider-icon">★</span>
            </div>
            <h2>Ready to Order?</h2>
            <p>Contact us for custom orders or browse our collection</p>
            <div className="cta-buttons">
              <button className="btn btn-primary" onClick={handleWhatsAppInquiry}>
                <span className="whatsapp-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20">
                    <path fill="currentColor" d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564c.173.087.289.129.332.202.043.073.043.423-.101.827z"/>
                  </svg>
                </span>
                Contact on WhatsApp
              </button>
              <Link to="/products" className="btn btn-secondary">
                View Products
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
